<template>
  <div
    :class="[
      $style.wrapper,
      isDisabled && $style.isDisabled
    ]"
    @click="$emit('click')"
  >
    <font-awesome-icon
      icon="play"
      :class="$style.icon"
    />
  </div>
</template>

<script>
export default {
  name: 'PlayIcon',
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style module lang="scss">
  @import "../../../assets/scss/variables";
  .wrapper {
    background-color: $color-tomato;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    height: 45px;
    width: 45px;
    transition: background-color .3s ease-in-out;
    cursor: pointer;
    &:hover {
      background-color: darken($color-tomato, 10%);
    }
    .icon {
      color: $color-white;
    }
    &.isDisabled {
      cursor: not-allowed;
      background-color: $color-jupiter;
      &:hover {
        background-color: darken($color-jupiter, 10%);
      }
    }
  }
</style>
